/* eslint class-methods-use-this: 0, no-param-reassign: 0 */
import { ReportSortFields } from 'Reports/constants/reportsConstants';
import { formatReportsList } from 'Reports/reportsCommonUtils';
import CollectionModule from 'client/store/modules/CollectionModule';
import ReportsApi from 'client/api/v2/ReportsApi';

export class ReportsCollectionClass extends CollectionModule {
  fetchCollection(context) {
    // set default sort to CREATED_AT descending
    const sortVal = context.state.features.items.sort && context.state.features.items.sort !== 'name' ? context.state.features.items.sort : ReportSortFields.created_at;

    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const reports = await ReportsApi.fetchReportsList({ sort: sortVal, skip: 0, limit: 10 });
      const payload = {
        results: formatReportsList(reports.data),
        totalCount: reports.data.length,
        totalCountOfAllItems: reports.data.length,
      };

      context.commit('RESET_COLLECTION', { soft: true });
      context.commit('SET_COLLECTION', payload);
      context.commit('BOUND_ITEMS_TOTAL_COUNT_HAS_BEEN_SET');

      return resolve(payload);
    });
  }

  refreshCollection(context) {
    return this.fetchCollection(context);
  }

  getInitialState() {
    const state = super.getInitialState();

    state.features = state.features || {};
    state.features.reportPending = false;

    return state;
  }

  extractModule() {
    // Binding the custom report methods to the module
    const module = super.extractModule();

    module.actions.setReportPending = (...params) => this.setReportPending(...params);

    module.getters.isReportMetadataPending = (...params) => this.isReportMetadataPending(...params);

    module.mutations.SET_REPORT_PENDING = (...params) => this.SET_REPORT_PENDING(...params);

    return module;
  }

  // --------------------------------------------------------------------------
  // Actions
  //

  setReportPending({ commit }, isPending) {
    commit('SET_REPORT_PENDING', isPending);
  }

  // --------------------------------------------------------------------------
  // Getters
  // --------------------------------------------------------------------------

  isReportMetadataPending({ features }) {
    const { reportPending } = features;
    return reportPending || false;
  }

  // --------------------------------------------------------------------------
  // Mutations
  // --------------------------------------------------------------------------

  SET_REPORT_PENDING(state, payload) {
    state.features.reportPending = payload;
  }
}

export default new ReportsCollectionClass(ReportsApi, 'id', 'name').extractModule();
